<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Configurações</li>
  </ol>
</div>

<div class="bio-page-header">
  <h4 class="bio-page-title">Configurações da Bio</h4>
  <p class="bio-page-subtitle">Personalize a aparência e as informações da sua página Bio</p>
</div>

<!-- Status Banner -->
<div class="bio-status-banner" *ngIf="!carregando && bioPagina"
     [ngClass]="{'is-active': bioPagina.ativo, 'is-inactive': !bioPagina.ativo}">
  <div class="status-banner-left">
    <span class="status-dot"></span>
    <span class="status-text">{{bioPagina.ativo ? 'Página Bio Ativa' : 'Página Bio Inativa'}}</span>
    <kendo-switch [ngModel]="bioPagina.ativo"
                  (valueChange)="toggleAtivo()"
                  [onLabel]="''"
                  [offLabel]="''">
    </kendo-switch>
  </div>
  <div class="status-banner-right" *ngIf="bioPagina.slug">
    <button class="btn-banner-action" (click)="copiarLink()" kendoTooltip title="Copiar link">
      <i class="fas fa-copy"></i> Copiar Link
    </button>
    <button class="btn-banner-action" (click)="abrirEmNovaAba()" kendoTooltip title="Abrir em nova aba">
      <i class="fas fa-external-link-alt"></i> Abrir
    </button>
  </div>
</div>

<!-- Loading -->
<div class="bio-loading" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<div class="bio-layout" *ngIf="!carregando && bioPagina">
  <!-- Coluna esquerda: Formulario -->
  <div class="form-panel">

    <!-- Seção: Identidade Visual -->
    <div class="bio-section bio-section--identity">
      <div class="bio-section-header">
        <div class="section-indicator">
          <i class="fas fa-store"></i>
        </div>
        <div class="section-label">
          <h6>Identidade Visual</h6>
          <p>Logo, nome e subtítulo do seu restaurante</p>
        </div>
      </div>
      <div class="bio-section-body">
        <div class="field-group">
          <span class="field-label">Logo</span>
          <app-upload-crop-imagem [objeto]="bioPagina" prop="urlLogo" label="Logo"
            ratio="1" [minHeight]="300" [minWidth]="300" [widthExibir]="200"
            [maiorPossivel]="true" [confirmarSalvar]="false"
            uploadUrl="/upload/imagem/logoempresa"></app-upload-crop-imagem>
        </div>

        <div class="field-row two-col">
          <div class="field-group">
            <span class="field-label">Nome do Restaurante</span>
            <kendo-textbox [(value)]="bioPagina.titulo" placeholder="Ex: Restaurante Sabor Caseiro"></kendo-textbox>
          </div>
          <div class="field-group">
            <span class="field-label">Subtítulo</span>
            <kendo-textbox [(value)]="bioPagina.subtitulo" placeholder="Ex: COMIDA BRASILEIRA ARTESANAL"></kendo-textbox>
            <span class="field-hint">Aparece em letras maiúsculas abaixo do nome</span>
          </div>
        </div>

      </div>
    </div>

    <!-- Seção: URL da Bio -->
    <div class="bio-section bio-section--url">
      <div class="bio-section-header">
        <div class="section-indicator">
          <i class="fas fa-link"></i>
        </div>
        <div class="section-label">
          <h6>URL da Bio</h6>
          <p>Endereço único da sua página Bio</p>
        </div>
      </div>
      <div class="bio-section-body">
        <div class="field-group">
          <span class="field-label">Slug</span>
          <div class="slug-input-wrapper">
            <span class="slug-prefix">bio/</span>
            <input type="text" [value]="bioPagina.slug"
                   (input)="onSlugInput($any($event.target).value)"
                   placeholder="meu-restaurante" />
            <span class="slug-status" *ngIf="slugDisponivel !== null && !verificandoSlug">
              <i class="fas" [ngClass]="{
                'fa-check-circle text-success': slugDisponivel,
                'fa-times-circle text-danger': !slugDisponivel
              }"></i>
            </span>
            <span class="slug-status" *ngIf="verificandoSlug">
              <i class="fas fa-circle-notch fa-spin text-muted"></i>
            </span>
          </div>

          <div class="slug-url-preview">
            <i class="fas fa-globe"></i>
            <span>URL completa: <strong>{{urlCompleta}}</strong></span>
          </div>

          <div class="slug-feedback is-taken" *ngIf="slugDisponivel === false">
            <i class="fas fa-exclamation-circle"></i>
            <span>Este slug já está em uso.</span>
          </div>

          <div class="slug-suggestions" *ngIf="slugDisponivel === false && sugestoesSlug.length > 0">
            <span *ngFor="let s of sugestoesSlug"
                  class="slug-suggestion-chip"
                  (click)="usarSugestao(s)">
              {{s}}
            </span>
          </div>

          <div class="slug-feedback is-available" *ngIf="slugDisponivel === true">
            <i class="fas fa-check-circle"></i>
            <span>Slug disponível!</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Seção: Badge Promocional -->
    <div class="bio-section bio-section--badge">
      <div class="bio-section-header">
        <div class="section-indicator">
          <i class="fas fa-tag"></i>
        </div>
        <div class="section-label">
          <h6>Badge Promocional</h6>
          <p>Destaque uma promoção ou mensagem especial</p>
        </div>
      </div>
      <div class="bio-section-body">
        <div class="field-group">
          <span class="field-label">Texto do Badge (opcional)</span>
          <kendo-textbox [(value)]="bioPagina.textoBadgePromocional"
                         placeholder="Ex: Mais barato do que no iFood!">
          </kendo-textbox>
          <span class="field-hint">Deixe vazio para não exibir o badge promocional</span>
        </div>

        <div class="badge-preview" *ngIf="bioPagina.textoBadgePromocional">
          <span class="badge-promo-sample">
            {{bioPagina.textoBadgePromocional}}
          </span>
        </div>
      </div>
    </div>

    <!-- Seção: Ofertas do Cardápio -->
    <div class="bio-section bio-section--ofertas">
      <div class="bio-section-header">
        <div class="section-indicator">
          <i class="fas fa-utensils"></i>
        </div>
        <div class="section-label">
          <h6>Ofertas do Cardápio</h6>
          <p>Exiba produtos em destaque na sua página Bio</p>
        </div>
      </div>
      <div class="bio-section-body">
        <div class="field-group toggle-field">
          <span class="field-label">Exibir ofertas do cardápio</span>
          <kendo-switch [(ngModel)]="bioPagina.exibirOfertas"
                        [onLabel]="''"
                        [offLabel]="''">
          </kendo-switch>
        </div>
        <span class="field-hint">Quando ativado, os produtos em destaque do seu cardápio serão exibidos na página Bio</span>

        <div class="field-group mt-3" *ngIf="bioPagina.exibirOfertas">
          <span class="field-label">Modo de exibição das ofertas</span>
          <div class="display-mode-selector mt-2">

            <div class="display-mode-option"
                 [class.is-active]="bioPagina.modoExibicaoOfertas === 'slide'"
                 (click)="bioPagina.modoExibicaoOfertas = 'slide'">
              <div class="dmo-icon">
                <i class="fas fa-images"></i>
              </div>
              <div class="dmo-info">
                <span class="dmo-title">Slide</span>
                <span class="dmo-desc">Carrossel deslizante</span>
              </div>
              <div class="dmo-check"><i class="fas fa-check"></i></div>
            </div>

            <div class="display-mode-option"
                 [class.is-active]="bioPagina.modoExibicaoOfertas === 'lista'"
                 (click)="bioPagina.modoExibicaoOfertas = 'lista'">
              <div class="dmo-icon">
                <i class="fas fa-list"></i>
              </div>
              <div class="dmo-info">
                <span class="dmo-title">Lista</span>
                <span class="dmo-desc">Itens empilhados</span>
              </div>
              <div class="dmo-check"><i class="fas fa-check"></i></div>
            </div>

          </div>
          <span class="field-hint">Escolha se as ofertas aparecerão em carrossel ou em uma lista vertical de produtos</span>
        </div>
      </div>
    </div>

    <!-- Botao Salvar -->
    <div class="save-bar">
      <button class="btn-save" (click)="salvar()" [disabled]="salvando">
        <i class="fas fa-check"></i>
        {{salvando ? 'Salvando...' : 'Salvar Configurações'}}
      </button>
    </div>
  </div>

  <!-- Coluna direita: Preview -->
  <div class="preview-panel">
    <span class="preview-label">Preview</span>

    <!-- Toggle Mobile/Desktop -->
    <div class="preview-mode-toggle">
      <button class="preview-mode-btn"
              [ngClass]="{'active': modoPreview === 'mobile'}"
              (click)="modoPreview = 'mobile'">
        <i class="fas fa-mobile-alt"></i> Mobile
      </button>
      <button class="preview-mode-btn"
              [ngClass]="{'active': modoPreview === 'desktop'}"
              (click)="modoPreview = 'desktop'">
        <i class="fas fa-desktop"></i> Desktop
      </button>
    </div>

    <!-- Frame -->
    <div class="phone-frame" [ngClass]="{'desktop-frame': modoPreview === 'desktop'}">
      <div class="phone-notch" *ngIf="modoPreview === 'mobile'"></div>
      <div class="phone-screen-inner">
        <iframe *ngIf="urlPreview"
                [src]="urlPreview"
                class="preview-iframe"
                frameborder="0"
                scrolling="yes">
        </iframe>
        <div *ngIf="!urlPreview" class="no-preview">
          <i class="fas fa-eye-slash"></i>
          <p>Configure o slug para visualizar o preview</p>
        </div>
      </div>
      <div class="phone-home-bar" *ngIf="modoPreview === 'mobile'"></div>
    </div>

    <div class="preview-actions" *ngIf="urlPreview">
      <button class="btn-refresh-preview" (click)="recarregarPreview()">
        <i class="fas fa-sync-alt"></i> Atualizar Preview
      </button>
      <button class="btn-open-page" (click)="abrirEmNovaAba()">
        <i class="fas fa-external-link-alt"></i> Abrir Página
      </button>
    </div>
  </div>
</div>
